@if (show && productType) {
  <div class="d-flex flex-column">
    <div class="d-flex justify-content-between px-1">
      @if (showNumber) {
        <div>
          <strong i18n>Order</strong>
        </div>
        <div>
          {{ productType }}
        </div>
        <div>
          {{ price }}
        </div>
      }
    </div>

    @if (showNumber) {
      <div class="input-group hide-number-scroll">
        <input
          type="number"
          class="form-control"
          [value]="params.value"
          (blur)="updateQuantity($event)"
          (keyup.enter)="updateQuantity($event)"
        />
        <span class="input-group-text">{{ unitOfMeasure }}</span>
      </div>
    }

    @if (sampleOutOfStockMessage) {
      <div [innerHTML]="sampleOutOfStockMessage"></div>
    }

    <div class="d-flex justify-content-between align-items-center">
      <!-- Add steps the quantity up by one only for "each"; for any other unit it opens a quantity
           modal, so it stays an ordinary guarded button there and a double click opens one modal. -->
      @if (isEach) {
        <app-repeat-click-button buttonClass="btn btn-primary" (clicked)="params.add(rowData)">
          <ng-container [ngTemplateOutlet]="addContent"></ng-container>
        </app-repeat-click-button>
      } @else {
        <button type="button" class="btn btn-primary" (click)="params.add(rowData)">
          <ng-container [ngTemplateOutlet]="addContent"></ng-container>
        </button>
      }
      <ng-template #addContent>
        @if (params.addIcon) {
          <i class="fa fa-{{ params.addIcon }}"></i>
        } @else if (!params.addButtonText) {
          <i class="fa fa-plus"></i>
        }
        {{ params.addButtonText }}
      </ng-template>

      @if (canMinus) {
        <app-repeat-click-button buttonClass="btn btn-info" (clicked)="params.minus(rowData)">
          <i class="fa fa-minus"></i>
        </app-repeat-click-button>
      }

      @if (canDelete) {
        <button type="button" class="btn btn-danger" (click)="params.remove(rowData)">
          <i class="fa fa-trash-alt"></i>
        </button>
      }
    </div>

    @if (total) {
      <div class="d-flex justify-content-between px-1">
        <div>
          <strong i18n>Total</strong>
        </div>
        <div>
          <strong>{{ total }}</strong>
        </div>
      </div>
    }
  </div>
}
